const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchAdminReleaseInterest(limit) {
  const url = new URL(`${API}/api/admin/release-interest`);
  if (limit) url.searchParams.set("limit", limit);
  const res = await fetch(url.toString(), { credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not load release interest data");
  }
  return res.json();
}
